import { getRequestHeader } from '../business/base';

function isString(opt: any) {
  return typeof opt === 'string';
}

/**
 * 序列化查询参数
 * @param {any} queryObj 查询对象
 * @return {string} 序列化后的查询字符串
 */
function serializeQueryParis(queryObj: any): string {
  const paramsQuery = Object.entries(queryObj || {})
    .map(function (item) {
      const k = item[0];
      const v = item[1];
      return encodeURIComponent(k) + '=' + encodeURIComponent(String(v));
    })
    .join('&');
  return paramsQuery;
}
/**
 * 构建请求URL
 * @param {RequestOptions} param 请求参数
 * @return {string} 完整的URL
 */
export function buildURL(param: RequestOptions): string {
  let fullURL = '';
  if (param.absoluteURL) {
    fullURL = param.absoluteURL;
  } else {
    const baseURL =
      location.protocol + '//' + process.env.JDX_APP_FETCH_DATA_DOMAIN;
    const path = param.path || '/monitor_control_client';
    fullURL = new URL(path, baseURL).href;
  }
  if (param.urlParams) {
    const paramsQuery = serializeQueryParis(param.urlParams);
    fullURL = addQueryParisToURL(fullURL, paramsQuery);
  }
  return fullURL;
}

function addQueryParisToURL(url: string, queryParis: string) {
  let fullURL = url;
  const hashPos = fullURL.indexOf('#');
  let fullURLNoHash = hashPos > 0 ? fullURL.substring(0, hashPos) : fullURL;
  const hash = hashPos > 0 ? fullURL.substring(hashPos, fullURL.length) : '';
  if (fullURLNoHash.indexOf('?') === -1) {
    fullURLNoHash += '?';
  } else if (!fullURLNoHash.endsWith('&')) {
    fullURLNoHash += '&';
  }
  fullURLNoHash += queryParis;
  fullURL = fullURLNoHash;
  if (hashPos) {
    fullURL += hash;
  }
  return fullURL;
}

/**
 * 构建fetch请求配置
 * @param {RequestOptions} param 请求参数
 * @return {RequestInit} fetch请求配置
 */
export function buildFetchInit(param: RequestOptions): RequestInit {
  const toReturn: RequestInit = {};
  const headerParams = getRequestHeader();
  const explicitLopDnKey = Object.keys(param.headers || {}).find(function (k) {
    return k.toLowerCase() === 'lop-dn';
  });
  const explicitLopDn =
    explicitLopDnKey && param.headers
      ? param.headers[explicitLopDnKey]
      : undefined;
  // 当param.method值为null或undefind时保底值为POST，避免param.method为0或者空串时也被转成POST
  toReturn.method = param.method != null ? param.method : 'POST';
  toReturn.credentials = 'include';
  toReturn.mode = 'cors';
  const headers: { [key: string]: string } = Object.assign({}, param.headers);
  headers['Content-Type'] = 'application/json';
  headers['Content-Language'] = 'zh-CN,zh;q=0.9';
  headers['Authorization'] = (window as any).Authorization;

  if (param.method === 'POST' || param.method === 'PUT') {
    if (param.contentType) {
      headers['Content-Type'] = param.contentType;
    } else {
      headers['Content-Type'] =
        typeof param.body === 'string' ? 'text/plain' : 'application/json';
    }
  }
  // 默认策略下保留默认header优先；当headerPriority=custom时以业务header优先
  const mergedHeaders: { [key: string]: string } =
    param.headerPriority === 'custom'
      ? Object.assign({}, headerParams, headers)
      : Object.assign({}, headers, headerParams);
  if (typeof explicitLopDn !== 'undefined') {
    Object.keys(mergedHeaders).forEach(function (k) {
      if (k.toLowerCase() === 'lop-dn') {
        delete mergedHeaders[k];
      }
    });
    mergedHeaders['LOP-DN'] = explicitLopDn;
  }
  toReturn.headers = mergedHeaders;
  const body = buildBody(param);
  if (body) {
    toReturn.body = body as string;
  }
  return toReturn;
}

/**
 * 构建请求体
 * @param {RequestOptions} param 请求参数
 * @return {string|null} 请求体字符串或null
 */
export function buildBody(param: RequestOptions): string | null {
  // 只处理POST和PUT请求的body数据
  if (!param.body) {
    return null;
  }

  if (param.method !== 'POST' && param.method !== 'PUT') {
    return null;
  }

  if (param.contentType === 'application/x-www-form-urlencoded') {
    if (isString(param.body)) {
      return param.body;
    } else {
      return serializeQueryParis(param.body);
    }
  } else if (param.contentType === 'application/json') {
    if (isString(param.body)) {
      return param.body;
    } else {
      return JSON.stringify(param.body);
    }
  } else {
    // 处理其他类型的body，确保返回字符串
    return typeof param.body === 'string' ? param.body : String(param.body);
  }
}

/**
 * 解析响应数据
 * @param {any} val 响应对象
 * @param {string|null} contentType 内容类型
 * @return {Promise<any>} 解析后的响应数据
 */
export function parseResponseData(
  val: any,
  contentType?: string | null
): Promise<any> {
  const ct = contentType || '';

  if (
    ct.indexOf('application/x-www-form-urlencoded') >= 0 ||
    ct.indexOf('text/plain') >= 0
  ) {
    const resp = val as Response;
    return resp.text();
  } else if (ct.indexOf('application/json') >= 0) {
    const resp = val as Response;
    return resp.json();
  } else {
    return Promise.resolve(val ? String(val) : '');
  }
}
